import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BookOpen } from 'lucide-react';
import LoadingSpinner from '@/components/ui/loading-spinner';

interface Search {
  id: number;
  query: string;
  created_at: string;
}

interface ResearchesSidebarProps {
  searches: Search[];
  selectedSearchId: string | null;
  isLoadingSearches: boolean;
  onSearchSelect: (searchId: string) => void;
  formatDate: (date: string) => string;
}

const ResearchesSidebar: React.FC<ResearchesSidebarProps> = ({
  searches,
  selectedSearchId,
  isLoadingSearches,
  onSearchSelect,
  formatDate
}) => {
  return (
    <div className="w-64 flex-shrink-0">
      <Card className="px-0">
        <CardHeader className="mb-1">
          <CardTitle className="flex items-center space-x-2">
            <BookOpen className="h-5 w-5" />
            <span>Researches</span>
          </CardTitle>
          <CardDescription>
            Select a research to view
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-4">
          {isLoadingSearches ? (
            <div className="py-4">
              <LoadingSpinner text="Loading searches..." />
            </div>
          ) : (
            <div className="space-y-2">
              {searches.map((search) => (
                <button
                  key={search.id}
                  onClick={() => onSearchSelect(search.id.toString())}
                  className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors hover:bg-muted ${
                    selectedSearchId === search.id.toString() ? 'bg-primary/10 text-foreground font-medium' : ''
                  }`}
                >
                  <div className="truncate">{search.query}</div>
                  <div className="text-xs text-muted-foreground mt-1">
                    {formatDate(search.created_at)}
                  </div>
                </button>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ResearchesSidebar;
